import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { ContentSectionResponse } from "../content-section/content-section.model";
import { FlagResponse } from "../flag/flag.model";
import { IconResponse } from "../icon/icon.model";
import { MenuResponse } from "../menu/menu.model";
import { QuicklinkResponse } from "../quicklink/quicklink.model";

import { ContentConfigService } from "./content.config";
import { ContentDocumentGroup, ContentGroupType, ImageContent } from "./content.model";
/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable({
	providedIn: "root",
})
export class ContentClient {
	constructor(
		private client: CoreHttpClient,
		private config: ContentConfigService
	) {}
	/**
	 * @deprecated - [fabric-deprecated] - Use documentRef.obgEventBus.retrieve(ContentValue.getTranslationGroups) instead
	 */
	getComponentGroupByName(groupName: string): Observable<Record<string, string>> {
		return this.client.get<Record<string, string>>({
			url: `${this.config.getComponentGroupEndpoint()}/:groupName`,
			searchParams: { groupName },
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getMenuContentGroup)" instead
	 */
	getMenuItems(menuName: string): Observable<MenuResponse> {
		return this.client.get<MenuResponse>({
			url: `${this.config.getMenuItemEndpoint()}/:menuName`,
			searchParams: { menuName },
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getQuickLinks)" instead
	 */
	getQuicklinks(): Observable<ContentDocumentGroup<QuicklinkResponse>> {
		return this.client.get<ContentDocumentGroup<QuicklinkResponse>>({
			url: this.config.getQuicklinkEndpoint(),
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getImage)" instead
	 */
	getImages(group: ContentGroupType): Observable<Record<string, ImageContent>> {
		return this.client.get<Record<string, ImageContent>>({
			url: this.config.getImagesEndpoint(group),
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getCurrentFlag_v2)" instead
	 */
	getFlags(): Observable<FlagResponse> {
		return this.client.get<FlagResponse>({
			url: this.config.getFlagsEndpoint(),
		});
	}
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(ContentValue.getContentSectionGroup) instead
	 */
	getContentSections(name: string): Observable<ContentDocumentGroup<ContentSectionResponse>> {
		return this.client.get<ContentDocumentGroup<ContentSectionResponse>>({
			url: this.config.getContentSectionsEndpoint(name),
		});
	}
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentValue.getIcons_v2)" instead
	 */
	getIcons(): Observable<ContentDocumentGroup<IconResponse>> {
		return this.client.get<ContentDocumentGroup<IconResponse>>({
			url: this.config.getIconEndpoint(),
		});
	}
}
